import { Record } from "appworks/model/gameplay/records/record";
import { Result } from "appworks/model/gameplay/records/results/result";
import { ReelModifierResult } from "slotworks/model/gameplay/records/results/reel-modifier-result";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { getSymbolImageData, gridDisplay } from "../general-displays/grid-display";

export function reelModifierResultDisplay(record: Record, result: Result) {
    const container = document.createElement("div");
    container.style.width = "10vw";
    container.style.height = "13vh";

    const reelDisplay = gridDisplay(record as SpinRecord);

    const symbols = reelDisplay.querySelectorAll(`[id*=symbol_]`);
    [].forEach.call(symbols, (symbol: HTMLElement) => {
        symbol.style.opacity = ".1";
    });

    const reelModifierResult = (result as ReelModifierResult);

    reelModifierResult.expansions.forEach((position) => {
        const symbol = reelDisplay.querySelector(`#symbol_${position.x}_${position.y}`) as HTMLElement;
        symbol.style.opacity = "1";
        symbol.style.backgroundImage = "url(" + getSymbolImageData(reelModifierResult.targetSymbolID) + ")";
        if (reelModifierResult.source?.equals(position)) {
            symbol.style.borderColor = "#f00";
        }
    });

    const infoDisplay = document.createElement("div");
    infoDisplay.style.width = "20vw";
    infoDisplay.innerText = `sourceSymbolId: ${reelModifierResult.sourceSymbolID}`;
    if (reelModifierResult.targetSymbolID) {
        infoDisplay.innerText += `\ntargetSymbolID: ${reelModifierResult.targetSymbolID}`;
    }

    if (reelModifierResult.modifierMeta) {
        infoDisplay.innerText = reelModifierResult.modifierMeta;
    }

    const reelDisplayContainer = document.createElement("div");
    reelDisplayContainer.style.height = "10vh";

    reelDisplayContainer.appendChild(reelDisplay);
    container.appendChild(reelDisplayContainer);
    container.appendChild(infoDisplay);

    return container;
}
